import { OrganizationAPI, TranslateAPI, UserAPI, UserPreferencesAPI, UserPreferencesInternalAPI } from '../api';
import type { RestService } from '../rest-service';
import { DefaultRestService } from '../rest-service';
import { isWindowDefined } from './is-window-defined';
import { setAPI } from './set-api';

/**
 * Defines and sets userAPI, translateAPI and organizationAPI, optionally using a custom RestService.
 * @param restService - (Optional) RestService instance to be used. If not provided, a default RestService instance will be used.
 */
export function defineAPIs(restService?: RestService): void {
  if (isWindowDefined()) {
    const defaultRestService = restService || new DefaultRestService();

    setAPI<UserAPI>('userAPI', new UserAPI(defaultRestService));
    setAPI<TranslateAPI>('translateAPI', new TranslateAPI(defaultRestService));
    setAPI<OrganizationAPI>('organizationAPI', new OrganizationAPI(defaultRestService));
    setAPI<UserPreferencesAPI>(
      'userPreferencesAPI',
      new UserPreferencesAPI(new UserPreferencesInternalAPI(defaultRestService)),
    );
  }
}
